import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';

@Enum<LanguageType>('value')
export class LanguageType extends EnumType<LanguageType>() {
   public static readonly GERMAN = new LanguageType('german', 0, true, 'de', 'common.global_settings.language.types.german', 'de');
   public static readonly ENGLISH = new LanguageType('english', 1, true, 'en', 'common.global_settings.language.types.english', 'en');
   public static readonly FRENCH = new LanguageType('french', 2, true, 'fr', 'common.global_settings.language.types.french', 'fr');
   public static readonly ITALIAN = new LanguageType('italian', 3, true, 'it', 'common.global_settings.language.types.italian', 'it');
   public static readonly CZECH = new LanguageType('czech', 4);
   public static readonly HUNGARIAN = new LanguageType('hungarian', 5);
   public static readonly SLOVENIAN = new LanguageType('slovenian', 6);
   public static readonly SLOVAK = new LanguageType('slovak', 7);
   public static readonly RUSSIAN = new LanguageType('russian', 8);
   public static readonly POLISH = new LanguageType('polish', 9);
   public static readonly DANISH = new LanguageType('danish', 10, true, 'da', 'common.global_settings.language.types.danish', 'da');
   public static readonly NORWEGIAN = new LanguageType('norwegian', 11);
   public static readonly SWEDISH = new LanguageType('swedish', 12);
   public static readonly PLACEHOLDER4 = new LanguageType('placeholder_4', 13);
   public static readonly PLACEHOLDER5 = new LanguageType('placeholder_5', 14);
   public static readonly DUTCH = new LanguageType('dutch', 15);

   public static valueByValueId(valueId: string): LanguageType {
      return _(LanguageType.values()).find((x) => x.value === valueId);
   }

   private constructor(
      public value: string,
      public samwinLegacyLanguageCode: number,
      public availableInWebAgent = false,
      public angularTranslationKey = 'en',
      public translationKey: string = value,
      public grafanaLanguageCode: string = 'en'
   ) {
      super();
   }
}
